import { reactive } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { ErrorMsgState, useErrorMsg } from '@/model/components/common/message/errorMessage'
import { NormalMsgState, useNormalMsg } from '@/model/components/common/message/normalMessage'
import { useUserPassword } from '@/model/api/user/apiUserPassword'
import { setAuth } from '@/model/components/users/userAuthinfo'
import { useStoreAction } from '@/model/store/store'
import * as RouterTypeData from '@/model/router/routerType'
import { MENU_TYPE } from '@/model/components/menu/sideMenuType'
import { PassUpdateState } from './userPasswordState'

/**
 * パスワード更新画面の初期状態を取得する
 * @returns reactiveした初期状態
 */
const usePassword = (): PassUpdateState => {
  const state = reactive<PassUpdateState>({
    loading: false,
    nowpassword: '',
    newpassword: '',
    newpasswordConfirm: '',
    dispPassword: false,
  })
  return state
}

/**
 * パスワード更新画面のDOM初期処理を実施する
 */
const initDom = async (store: Store<StoreState>, router: Router) => {
  // 一旦ログイン済みにする
  useStoreAction(store).login()
  // ユーザー認証情報を設定(認証済みの場合は何もしない)
  const data: RouterTypeData.LoginTopData = {
    redirect: RouterTypeData.REDIRECT_TYPE.PASSWORD_UPDATE,
  }
  const authResult = await setAuth(store, router, data)
  // 認証が成功した場合のみ後続の処理を実行
  if (!authResult) {
    return
  }
  // メニュー情報を設定
  useStoreAction(store).menu(MENU_TYPE.PASSWORD_UPDATE)
}

/**
 * パスワード更新処理を実施する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 * @param error エラーメッセージ状態
 * @param normal 正常メッセージ状態
 */
const passwordUpdate = async (
  state: PassUpdateState,
  store: Store<StoreState>,
  router: Router,
  error: ErrorMsgState,
  normal: NormalMsgState
) => {
  // 一旦メッセージを全て初期化
  normal.data.splice(0)
  error.data.splice(0)
  // ローディングをONにする
  state.loading = true
  // api送信を実施
  await useUserPassword(router, store).update(state, error, normal)
  // ローディングをOFFにする
  state.loading = false
}

export {
  PassUpdateState,
  usePassword, //
  passwordUpdate, //
  initDom,
  useErrorMsg, //
  useNormalMsg, //
}
